export default {
    modalShowImageVariations: {
        imageAi: 'Image AI',
        regenerateImage: 'Generate new content',
        description: 'Description',
        style: 'Style',
        saveToLibrary: 'Save to Library',
        continue: 'Continue',
        cancel: 'Cancel',
        select: 'Select',
        copy: 'Copy',
        selectedImage: 'Selected Image',
        saved: 'Saved',
        variations: 'Variations:',
    },
};
